/**
 * A set containing all available time zones in browser/environment
 * If the environment does not support to list them, the value will be undefined
 */
const availableTimeZones: Set<string> | undefined = Intl.supportedValuesOf
    ? new Set(Intl?.supportedValuesOf?.("timeZone"))
    : undefined;

export { availableTimeZones };
